import React from 'react';
import Card, { CardProps } from './Card';
import './CardSection.scss';

type CardSectionProps = {
  id: string;
  title: string;
  cards: CardProps[];
};

const CardSection = ({ id, title, cards }: CardSectionProps): JSX.Element => {
  const containerClass =
    cards.length % 2 === 0 ? 'card-container-even' : 'card-container-odd';

  return (
    <div id={id} className='card-section flex-row'>
      <h3>{title}</h3>
      <div className='flex-row cards'>
        {cards.map((card, cardIndex) => {
          return (
            <div key={`${id}-${cardIndex}`} className={containerClass}>
              <Card
                id={card.id}
                cardNumber={card.cardNumber}
                title={card.title}
                description={card.description}
                source={card.source}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CardSection;
